import { Inject, Injectable } from '@angular/core';

import { L10nBase } from '@skylab-shared/core';

import { L10n } from '@skylab-angular-shared/core';
import { ServiceGridColumn } from '@skylab-angular-shared/ui';
import { FiscalDeviceVatRatesParametersMappingModelWrapper } from '../../fiscal-device-dialog-grid-item';

export type FiscalDeviceDialogVatRatesGridColumnIdentitiy = 'mapped' | 'physicalVatRateSymbol' | 'vatRateId' | 'select';
export type FiscalDeviceDialogVatRatesGridCustomTemplates = 'fiscalDeviceDialogVatRateTemplate' | 'fiscalDeviceDialogTechnicalZeroTemplate';

@Injectable({
    providedIn: 'root'
})
export class FiscalDeviceDialogVatRatesGridService {

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase
    ) {}

    public getGridColumns(): ServiceGridColumn<FiscalDeviceDialogVatRatesGridColumnIdentitiy, unknown, FiscalDeviceVatRatesParametersMappingModelWrapper, unknown, FiscalDeviceDialogVatRatesGridCustomTemplates>[] {
        return [
            {
                header: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.vat-rate-symbol.short-title'),
                headerTooltip: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.vat-rate-symbol.full-title'),
                identityName: 'mapped',
                columnDef: 'mapped',
                width: '45px',
                cell: entity => entity.model.mapped,
                styleClass: 'column--align-center',
                isResizable: false,
                isMovable: false,
            },
            {
                header: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.vat-rate-value.short-title'),
                headerTooltip: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.vat-rate-value.full-title'),
                identityName: 'physicalVatRateSymbol',
                columnDef: 'physicalVatRateSymbol',
                cell: entity => entity.physicalVatRateSymbol,
                styleClass: 'column--align-center',
                width: '55px',
                isResizable: false,
                isMovable: false,
            },
            {
                header: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.system-vat-rate.title'),
                identityName: 'vatRateId',
                columnDef: 'vatRateId',
                minWidth: '100px',
                fillingColumn: true,
                isResizable: false,
                isMovable: false,
                template: 'fiscalDeviceDialogVatRateTemplate',
            },
            {
                header: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.technical-zero.short-title'),
                headerTooltip: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.technical-zero.full-title'),
                columnDef: 'select',
                identityName: 'select',
                styleClass: 'column--align-center',
                isResizable: false,
                isMovable: false,
                width: '65px',
                template: 'fiscalDeviceDialogTechnicalZeroTemplate'
            }
        ];
    }
}
